export default "__VITE_ASSET__C_py9mTo__"